import { lazy } from "react";

const RETRIES = 5;
const INTERVAL = 1000;

function retryChunk(fn, retriesLeft = RETRIES, interval = INTERVAL) {
  return new Promise((res, rej) => {
    fn()
      .then(res)
      .catch((err) => {
        if (retriesLeft === 1) {
          // After all retries exhausted, reload if it's a stale chunk error
          // (happens when deployment changes hashed filenames while users have old page open)
          if (
            err.message &&
            err.message.includes("Failed to fetch dynamically imported module")
          ) {
            window.location.reload();
            return;
          }
          return rej(err);
        }

        setTimeout(() => {
          return retryChunk(fn, retriesLeft - 1, interval).then(res, rej);
        }, interval);
      });
  });
}

export default (fn) => lazy(() => retryChunk(fn));
